import { HTTP } from '../../utils'

export const getCurrentEnvironment = () => {
  return HTTP().get('/configuration')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const uploadFileOnKhub = (learningSpaceId, contents, success, failure) => {
  var url = '/learningcontent/uploadContentFromS3/' + learningSpaceId
  return HTTP().post(url, contents).then(res => {
    success(res.data)
  })
  .catch(e => {
    failure(e.response)
    console.log('Error: ', e)
  })
}

export const uploadFileOnKhubWithReturn = (learningSpaceId, contents, success, failure) => {
  var url = '/learningcontent/uploadContentFromS3/' + learningSpaceId
  return HTTP().post(url, contents).then(res => {
    success(res.data)
  })
  .catch(e => {
    console.log('Error: ', e)
    failure(e.response)
  })
}
export const doUploadForScorm = (owningLibraryId, fileData) => {
  let url = '/scorm/upload/new/?owningLibraryId=' + owningLibraryId 
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getCSVContent = (data, success) => {
  return HTTP().post('/learningcontent/getContentFromCsv', data).then(res => {
    success(res.data)
  })
  .catch(e => {
    console.log('Error: ', e)
  })
}

export const uploadContentFromCsv = (learningSpaceId, contents, success, failure) => {
  var url = '/learningcontent/uploadContentFromCsv/' + learningSpaceId
  return HTTP().post(url, contents).then(res => {
    success(res.data)
  })
  .catch(e => {
    failure(e.response)
    console.log('Error: ', e)
  })
}

export const updateFileUriAndVersionId = (data) => {
  return HTTP().put('learningcontent/updateUriWithVersionId', data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const updateAsset = (data) => {
  var url = 'learningcontent'
  if (data.uuid) {
    url += '/' + data.uuid
  }
  return HTTP().put(url + '?parentSpaceId=' + data.ancestor, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAncestorName = (uuid) => {
  return HTTP().get('learningcontent/ancestorName/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/learningContent/api.js